import React, { useEffect, useState } from 'react';
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  Slide,
  ModalOverlay,
  useDisclosure,
  Box,
  IconButton,
} from '@chakra-ui/react';
import { HiOutlineChevronRight, HiOutlineChevronLeft } from 'react-icons/all';
import { useCallback } from 'react';

interface ModalProps {
  children: any;
  textBtn: string;
}

export const Accordion = (props: ModalProps): JSX.Element => {
  const { children, textBtn } = props;
  const [windowOffset, setWindowOffset] = useState<number>(0);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOpen = useCallback(() => {
    onOpen();
    setWindowOffset(window.scrollY);

    document.body.setAttribute(
      'style',
      `position: fixed; top: -${window.scrollY}px; left:0; right:0;`,
    );
  }, [isOpen]);

  const handleClose = useCallback(() => {
    onClose();
    document.body.setAttribute('style', '');
    window.scrollTo(0, windowOffset);
  }, [isOpen, windowOffset]);

  useEffect(() => {
    return () => {
      handleClose();
    };
  }, []);

  return (
    <>
      <Box
        pl={{ sm: 0, md: 4, lg: 4, xl: 4 }}
        pr={{ sm: 0, md: 4, lg: 4, xl: 4 }}
        pt={0}
        pb={0}
        borderRadius={{ sm: 0, md: 0, lg: 0, xl: 4 }}
        borderWidth={1}
        borderColor={'gray.300'}
        backgroundColor={'white'}
        alignItems={'center'}
        justify={'space-between'}
        w={'100%'}>
        <Button
          mt={2}
          mb={2}
          rightIcon={<HiOutlineChevronRight />}
          variant="ghost"
          fontSize={'15px'}
          align="center"
          colorScheme={'blue'}
          onClick={handleOpen}
          cursor={'pointer'}
          w={'100%'}
          display={'flex'}
          justifyContent={'space-between'}>
          {textBtn}
        </Button>
      </Box>
      <Slide direction="right" in={isOpen} style={{ zIndex: 102 }}>
        <Box h={'100%'} w={'100%'} color="white" shadow="md">
          <Box bg={'white'} p={2} w={'100%'}>
            <Button
              leftIcon={<HiOutlineChevronLeft />}
              variant="ghost"
              fontSize={'15px'}
              colorScheme={'blue'}
              onClick={handleClose}
              cursor={'pointer'}
              w={'100%'}
              display={'flex'}
              justifyContent={'flex-start'}>
              {textBtn}
            </Button>
          </Box>
          {typeof children === 'function' ? children(handleClose) : children}
        </Box>
      </Slide>
    </>
  );
};
